/** All links on the page. */
const getLinks = (): NodeListOf<HTMLAnchorElement> =>
  document.querySelectorAll("a");

/** Check if a link is for an external website. */
const isExternalLink = (link: HTMLAnchorElement): boolean =>
  link.hostname !== window.location.hostname;

/** Check if a link is for a file i.e. ends in an extension. */
const isFileLink = (link: HTMLAnchorElement): boolean =>
  link.pathname.match(/\.(\w{3,4})$/) !== null;

/** Check if a link is not excluded from opening in a new tab. */
const isNotExcludedLink = (link: HTMLAnchorElement): boolean =>
  link.classList.contains("js-external-link-exclude") === false;

/** Make a link open in a new tab. */
const addExternalAttributes = (link: HTMLAnchorElement): HTMLAnchorElement => {
  link.setAttribute("target", "_blank");
  link.setAttribute("rel", "noopener noreferrer");

  return link;
};

export default Array.from(getLinks())
  .filter((link) => isExternalLink(link) || isFileLink(link))
  .filter(isNotExcludedLink)
  .map(addExternalAttributes);
